// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["css/bgr"], () => (__webpack_require__("./src/js/bgr.js")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["css/bgr"], () => (__webpack_require__("./src/scss/bgr.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
